import moment from 'moment'
import { createApolloFetch } from 'apollo-fetch'

export const fireEvent = (eventType, eventDataObj, sourceModel, sourceId) => {
  let input = {
    sourceModel,
    sourceId,
    eventType,
    eventData: JSON.stringify(eventDataObj),
    eventAt: moment().toISOString()
  }

  const uri = process.env.REACT_APP_GRAPHQL_ROOT
  const apolloFetch = createApolloFetch({ uri })

  // apply middleware
  apolloFetch.use(({ request, options }, next) => {
    if (!options.headers) {
      options.headers = {}  // create the headers object if needed
    }
    // get the authentication token from local storage if it exists
    options.headers['authorization'] = "Token " + localStorage.getItem('token') || null
    next()
  })

  const query = `
    mutation createEvent($input: EventMutationInput!) {
      eventMutate(input: $input) {
        event {
          id
        }
      }
    }
  `

  const variables = {
    input
  }

  apolloFetch({ query, variables })
    .then(result => {
      if (!result.error) {
        console.log("Event created successfully", result)
      } else {
        console.log("Event creation failed", result)
      }
    })
    .catch(error => {
      console.log("Event creation failed", error)
    })
}



// WEBPACK FOOTER //
// ./src/utils/event/index.js